import { ConstValues, OrderlinePreflightErrorCodes } from '@/ConstValues';
import { CustomerService } from '@/services/customer-service';
import { OrdersService } from '@/services/orders-service';
import { Address } from '@/store/models/AddressModel';
import { Orderline, OrderlineDetails, Quote } from '@/store/models/OrderlineModel';
import store from '@/store/modules/index';
import { ConversionHelper } from './ConversionHelper';
import { isOrderlineDetails } from './ObjectHelper';
import { SetSnackBar } from './SnackbarHelper';
import { ValidationHelper } from './ValidationHelper';
export function RefreshCart() {
  store.dispatch('orderlines/GetShoppingCart');
}

export async function GetNewOrderPo(shouldCreateNewPo: boolean = false): Promise<string> {
  let newOrderPo = localStorage.getItem(ConstValues.NEW_ORDER_PO);
  if (!newOrderPo || shouldCreateNewPo) {
    const { data } = await OrdersService.CreateDefaultPo();
    newOrderPo = data;
    SetNewOrderPo(data);
  } else {
    newOrderPo = JSON.parse(newOrderPo);
  }
  return newOrderPo as string;
}

export function SetNewOrderPo(newPo: string) {
  localStorage.setItem(ConstValues.NEW_ORDER_PO, JSON.stringify(newPo));
}
export function IsLikeItem(ol: OrderlineDetails, olToCheck: OrderlineDetails) {
  return (
    ol.Die.Description == olToCheck.Die.Description &&
    ol.Material.BadgeText == olToCheck.Material.BadgeText &&
    ol.Finish.BadgeText == olToCheck.Finish.BadgeText &&
    ol.Color.ClickColors == olToCheck.Color.ClickColors
  );
}

export async function CalculatePrice(
  ols: Array<OrderlineDetails | Orderline>,
  quote: Quote = new Quote()
) {
  let model = ols.map((ol: OrderlineDetails | Orderline) => {
    let orderline;
    if (isOrderlineDetails(ol)) {
      orderline = ConversionHelper.convertOrderlineToAddModel(ol as OrderlineDetails);
    } else {
      orderline = ConversionHelper.convertOrderlineToAddModel(ol as Orderline);
    }
    if (quote.IsQuote) {
      return { ...orderline, ...quote };
    } else {
      return orderline;
    }
  });
  const { data } = await OrdersService.CalculatePricingData(model);
  if (quote.IsQuote) {
    return data;
  }
  return data.map((d: any) => new OrderlineDetails(d));
}

export async function OrderlinePreflightCheck(
  ol: OrderlineDetails
): Promise<OrderlinePreflightErrorCodes[]> {
  let returnValue = [];
  if (!store.getters['customer/getCustomer'].BillingAddress.Id)
    returnValue.push(OrderlinePreflightErrorCodes.MissingBillingAddress);
  let { data } = await CustomerService.GetAddress(ol.Address.Id);
  ol.Address = new Address(data);
  if (!ValidationHelper.IsAddressValid(ol.Address))
    returnValue.push(OrderlinePreflightErrorCodes.ShippingAddressNotComplete);
  return returnValue;
}
